<div class="container">
    <section class="inner-container">
    <div class="products" style="background: white">
  <div class="content-container">
    <div class="text-center">
      <h1 class="title-default intro-title">Payment Notification Technical Requirement</h1>
      <p class="text-intro">Once your customer completes a payment, we will send you a payment notification to your Response URL.</p>
      <hr class="yellow-line-large">
      <p class="text-intro yellow">Please consult your technical team before completing this page</p>
      <p class="text-intro">Fields with asterisk (*) are mandatory</p>

    </div>
    <div class="inner">
      <div class="flex-wrap scroll_m2uPay">
            <form (change)="notSaved()" name="pay" id="pay" data-k2-validation="true" novalidate class="col-sm-8 general-form" style="padding: 0"> 
                
                <div class="row boxx">
                    <div class="col-md-6">
                        <b>Message Format</b><br>
                        We will send you the notification in <b>JSON</b> message format
                    </div>
                    <div class="col-md-6">
                        <b>Notification Type</b><br>
                        We will send you notifications for <b>all transactions</b> with status code <br>
                        (00 – Success / 01 – Fail)
                    </div>
                </div>

                <h5 class="title-form"> Response URL and Port Number </h5>
                <label>Specify the Response URL and Port Number for us to send you payment notifications.</label><br>
                <label class="yellow">NB: Please ensure you provide the correct Response URL. Any update/changes to the Reponse Url will take 5 working days to take effect, which will pro-long your Testing &amp; Go Live date.</label><br><br>
                
                <div class="row boxx">
                    <div class="col-md-12">
                        <b>Response URL</b>: an end point in your website that can accept the payment status from Maybank after payment has been made.<br>
                        <div style="font-style: italic">This is <span style="text-decoration: underline">not</span> a redirect URL.</div>
                
                        EXAMPLE:<br>
                        Your Website URL : www.website.com<br>
                        Your Response URL : www.website.com/payment_notification
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="group">
                            <input type="text" name="uat_url" id="uat_url" [(ngModel)]="details.response_url_uat" placeholder="" class="custom-input" required data-rules="required" data-error-mes="This field is required" [disabled]="techSpecDisabled">
                            <label> User Acceptance Testing (UAT)* </label>
                        </div>
                        <label>Response URL for UAT</label>
                    </div>
                    <div class="col-md-6">
                        <div class="group">
                            <input type="text" maxlength="5" name="uat_port" id="uat_port" [(ngModel)]="details.port_uat" placeholder="" class="custom-input" required data-rules="required|port" data-error-mes="This field is required|The port number must be an integer between 0 and 65535" [disabled]="techSpecDisabled">
                            <label> Port Number* </label>
                        </div>
                        <label>Port Number for UAT</label>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="group">
                            <input type="text" name="prod_url" id="prod_url" [(ngModel)]="details.response_url_production" placeholder="" class="custom-input" required data-rules="required" data-error-mes="This field is required" [disabled]="techSpecDisabled">
                            <label> Production* </label>
                        </div>
                        <label>Response URL for Production</label>
                    </div>
                    <div class="col-md-6">
                        <div class="group">
                            <input type="text" maxlength="5" name="prod_port" id="prod_port" [(ngModel)]="details.port_production" placeholder="" class="custom-input" required data-rules="required|port" data-error-mes="This field is required|The port number must be an integer between 0 and 65535" [disabled]="techSpecDisabled">
                            <label> Port Number* </label>
                        </div>
                        <label>Port Number for Production</label>
                    </div>
                </div>

                <h5 class="title-form"> SSL Certificate </h5>
                <label>Required to establish a secure connection with your Response URL.</label><br>
                <label class="yellow">NB: Payment notification will fail to reach you if you provide an incorrect SSL Certificate.</label><br>
                
                <div class="row boxx">
                    <div class="col-md-12">
                        <ul>
                            <li>The standard SSL certificate authorities are <b>Comodo</b> or <b>Versign</b>.</li>
                            <li>Please upload the SSL Certificates for both environments associated with the UAT and Production URLs respectively.</li>
                            <li>SSL certificates can be in the <b>.cer</b> or <b>.crt</b> format or you may compile it into one <b>zip</b> file.</li>
                        </ul>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-6">
                                <h5>
                                    SSL Certificate for UAT environment* <br>
                                </h5>
                                <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="uatSSL">
                                    <input *ngIf=(!techSpecDisabled) (change)="addDoc('uat_ssl', $event)" accept="*.crt, *.cer, *.zip,application/pkix-cert, application/x-x509-user-cert, application/zip" #uatSSLInput type="file" name="uatSSL"/>
                                </div>
                                <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="!uatSSL">
                                    <a [href]="getFileUrl(uatSSL)" download class="link" title="Download">Download</a> &nbsp; &emsp;
                                    <a *ngIf=(!techSpecDisabled) (click)="uatSSL = null; uatSSLInput.value = ''" class="link">Delete</a>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <h5>
                                    SSL Certificate for Production environment* <br>
                                </h5>
                                <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="prodSSL">
                                    <input *ngIf=(!techSpecDisabled) (change)="addDoc('prod_ssl', $event)" accept="application/pkix-cert, application/x-x509-ca-cert, application/zip" #prodSSLInput type="file" name="prodSSL"/>
                                </div>
                                <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="!prodSSL">
                                    <a [href]="getFileUrl(prodSSL)" download class="link" title="Download">Download</a> &nbsp; &emsp;
                                    <a *ngIf=(!techSpecDisabled) (click)="prodSSL = null; prodSSLInput.value = ''" class="link">Delete</a>
                                </div>
                            </div>
                        </div>
                        <div class="row" [hidden]="valid || docsValid">
                            <div class="col-md-12">
                                <label class="red">All documents marked with a * are required</label>
                            </div>
                        </div>
                        <div *ngIf="uploader" [hidden]="uatSSL && prodSSL">
                            Upload Progress: {{uploader.queue[0] ? uploader.queue[0].progress : 0}}%
                            <div class="progress">
                                <div class="progress-bar progress-bar-success" role="progressbar" [ngStyle]="{ 'width': (uploader.queue[0] ? uploader.queue[0].progress : 0) + '%' }">
                                    <span style="opacity: 0">...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <h5 class="title-form"> Technical Representative's Contact Details </h5>     
                <div class="row">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="custom-radio">
                                    <label for="inHouse"><input type="radio" id="inHouse" value="In House" name="repType" [(ngModel)]="details.developer_type" #repType="ngModel" required [disabled]="techSpecDisabled"/>
                                        <span>
                                            In House
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="custom-radio">
                                    <label for="freelance"><input type="radio" id="freelance" value="Freelance" name="repType" [(ngModel)]="details.developer_type" #repType="ngModel" required [disabled]="techSpecDisabled"/>
                                        <span>
                                            Freelance
                                        </span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="custom-radio">
                                    <label for="outsource"><input type="radio" id="outsource" value="Outsource" name="repType" [(ngModel)]="details.developer_type" #repType="ngModel" required [disabled]="techSpecDisabled"/>
                                        <span>
                                            Outsource
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row noBP" [hidden]="valid || repType.value">
                            <div class="col-md-12">
                                <label class="red">Please choose one of the above</label>
                            </div>
                        </div> 
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="group">
                            <input type="text" name="repName" id="repName" [(ngModel)]="details.developer_name" placeholder="" class="custom-input" required data-rules="required" data-error-mes="This field is required" [disabled]="techSpecDisabled">
                            <label> Name* </label>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="group">
                            <input type="text" name="repNo" id="repNo" [(ngModel)]="details.developer_contact_no" placeholder="" class="custom-input" required data-rules="required" data-error-mes="This field is required" [disabled]="techSpecDisabled">
                            <label> Contact No* </label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="group">
                            <input type="text" name="repEmail" id="repEmail" [(ngModel)]="details.developer_email" placeholder="" class="custom-input" required data-rules="required|email" data-error-mes="This field is required|Please enter a valid e-mail address" [disabled]="techSpecDisabled">
                            <label> E-mail Address* </label>
                        </div>
                    </div>
                </div>

                


                <div class="row" id="save_m2uPay">
                  <div class="col-md-2">
                    
                    
                  </div>                    
                  <div class="col-md-4">
                  </div>
                  <div class="col-md-3">
                  
                  </div>
                  <button [hidden]="true" #paySubmit type="submit">Submit</button>
                  <div *ngIf=(!techSpecDisabled) class="col-md-3">
                    <button type="button" class="btn btn-primary btn-block" (click)="submitOnlineBankingTechReq()">Submit</button>
                  </div>
                </div>
            </form>
      </div>
    </div>
  </div>
</div>
</section>
</div>
